import { render, staticRenderFns } from "./Top.vue?vue&type=template&id=bb265ac0&scoped=true&"
import script from "./Top.vue?vue&type=script&lang=js&"
export * from "./Top.vue?vue&type=script&lang=js&"
import style0 from "./Top.vue?vue&type=style&index=0&id=bb265ac0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb265ac0",
  null
  
)

export default component.exports